import {
    PARTNER_API_DOCS_CREATE_LEAD_REQUEST_PARAMETERS,
    PARTNER_API_DOCS_CREATE_LEAD_RESPONSE_PARAMETERS,
    PARTNER_API_DOCS_CREATE_LEAD_SAMPLE_REQUEST,
    PARTNER_API_DOCS_CREATE_LEAD_SAMPLE_RESPONSE,
} from "./partnerApiDocsCreateLeadConstants";
import { PartnerApiDocsPreStyled } from "../styled/PartnerApiDocsStyled";
import PartnerApiDocsRequestParams from "../components/PartnerApiDocsRequestParams/PartnerApiDocsRequestParams";
import PartnerApiDocsResponseParams from "../components/PartnerApiDocsResponseParams/PartnerApiDocsResponseParams";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

function PartnerApiDocsCreateLead(props) {
    const {getLangPath} = useLangContext();
    return <>
        <h1>{getLangPath('partner.api_docs.methods.create_lead.title')}</h1>

        <h4 className="mt-5">{getLangPath('partner.api_docs.description')}</h4>
        <p>Creates new lead account</p>

        <h4 className="mt-5">{getLangPath('partner.api_docs.url')}</h4>
        <PartnerApiDocsPreStyled>
            https://fx.binomo.com/api/v1/public/partner/lead/create
        </PartnerApiDocsPreStyled>

        <h4 className="mt-5">{getLangPath('partner.api_docs.request_method')}</h4>
        <p>POST</p>

        <h4 className="mt-5">{getLangPath('partner.api_docs.content_type')}</h4>
        <p>application/json</p>

        <PartnerApiDocsRequestParams
                className="mt-5"
                params={PARTNER_API_DOCS_CREATE_LEAD_REQUEST_PARAMETERS}
        />

        <PartnerApiDocsResponseParams
                className="mt-5"
                params={PARTNER_API_DOCS_CREATE_LEAD_RESPONSE_PARAMETERS}
        />

        <h4 className="mt-5">{getLangPath('partner.api_docs.sample_request_response')}</h4>
        <h5 className="mt-4">{getLangPath('partner.api_docs.request')}</h5>
        <PartnerApiDocsPreStyled>
            {PARTNER_API_DOCS_CREATE_LEAD_SAMPLE_REQUEST}
        </PartnerApiDocsPreStyled>
        <h5 className="mt-4">{getLangPath('partner.api_docs.response')}</h5>
        <PartnerApiDocsPreStyled>
            {PARTNER_API_DOCS_CREATE_LEAD_SAMPLE_RESPONSE}
        </PartnerApiDocsPreStyled>
    </>
}

export default PartnerApiDocsCreateLead;
